import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Network } from '@ionic-native/network/ngx';
import { Storage } from '@ionic/storage';
import { saveAs } from 'file-saver';

@Injectable()
export class RestProvider {

  private mainUrl = 'https://api.bifrost.health/api/';
  public isShowLog = 0;
  disconnectSubscription;
  connectSubscription;
  keyDownloadProscription = "yvJ6XDRRv3eAzIei4COYHp1suQLRTIYmqsCMfvxF796dmpZyrACW9A=="

  constructor(public http: HttpClient,
    public network: Network,
    public storage: Storage,) {
    //Register for network observer
    this.disconnectSubscription = this.network.onDisconnect().subscribe(() => {
      this.storage.set('networkState', 0);
    });
    this.connectSubscription = this.network.onConnect().subscribe(() => {
      this.storage.set('networkState', 1);
    });
  }

  registerUser(mailID) {
    return new Promise((resolve, reject) => {
      this.http.get(this.mainUrl + 'tenant/signup?admin=' + mailID, {
        headers: new HttpHeaders()
          .append('Content-Type', 'application/json')
      })
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          reject(err);
        });
    });
  }

  verifyUser(mailID, uid) {
    return new Promise((resolve, reject) => {
      this.http.get(this.mainUrl + 'tenant/verify', {
        headers: new HttpHeaders()
          .append('Content-Type', 'application/json')
          .append('admin', mailID)
          .append('uuid', uid)
      })
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          reject(err);
        });
    });
  }

  getUsersList(mailID, uid, roal) {
    return new Promise((resolve, reject) => {
      this.http.get(this.mainUrl + 'tenant/users/list?role=' + roal, {
        headers: new HttpHeaders()
          .append('Content-Type', 'application/json')
          .append('admin', mailID)
          .append('uuid', uid)
      })
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          reject(err);
        });
    });
  }

  saveUserDeatils(mailID, uid, UserName, UserMail, dep, role, approved, telemedicine) {
    var data = [{ name: UserName, email: UserMail, department: dep, role: role, approved: approved, telemedicine: telemedicine }];
    return new Promise((resolve, reject) => {
      this.http.post(this.mainUrl + 'tenant/users/access', JSON.stringify(data), {
        headers: new HttpHeaders().append('Content-Type', 'application/json')
          .append('admin', mailID)
          .append('uuid', uid)
      })
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          reject(err);
        });
    });
  }

  savePracticeInfo(mailID, uid, practice) {
    var data = [practice];
    return new Promise((resolve, reject) => {
      this.http.post(this.mainUrl + 'tenant/users/practice', JSON.stringify(data), {
        headers: new HttpHeaders().append('Content-Type', 'application/json')
          .append('admin', mailID)
          .append('uuid', uid)
      })
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          reject(err);
        });
    });
  }

  getExaminarConsultentList(mailID, uid, roal) {
    return new Promise((resolve, reject) => {
      this.http.get(this.mainUrl + 'tenant/users/list?role=' + roal, {
        headers: new HttpHeaders()
          .append('Content-Type', 'application/json')
          .append('admin', mailID)
          .append('uuid', uid)
      })
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          reject(err);
        });
    });
  }

  getExaminarConsultentListWithCenter(mailID, uid, roal, centerCode) {
    return new Promise((resolve, reject) => {
      this.http.get(this.mainUrl + 'tenant/users/list?role=' + roal + "&center_code=" + centerCode, {
        headers: new HttpHeaders()
          .append('Content-Type', 'application/json')
          .append('admin', mailID)
          .append('uuid', uid)
      })
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          reject(err);
        });
    });
  }

  getSlotsInfomation(mailID, uid, userMail, timezone, formDate, todate) {
    return new Promise((resolve, reject) => {
      this.http.get(this.mainUrl + 'tenant/tele/consultant/schedule?email=' + userMail + '&timezone=' + timezone + '&from=' + formDate + '&to=' + todate, {
        headers: new HttpHeaders()
          .append('Content-Type', 'application/json')
          .append('admin', mailID)
          .append('uuid', uid)
      })
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          reject(err);
        });
    });
  }

  updateSlotsInfo(mailID, uid, data) {
    return new Promise((resolve, reject) => {
      this.http.post(this.mainUrl + 'tenant/tele/consultant/schedule', JSON.stringify(data), {
        headers: new HttpHeaders().append('Content-Type', 'application/json')
          .append('admin', mailID)
          .append('uuid', uid)
      })
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          reject(err);
        });
    });
  }

  getTestCenters(mailID, uid) {
    return new Promise((resolve, reject) => {
      this.http.get(this.mainUrl + 'tenant/centres', {
        headers: new HttpHeaders()
          .append('Content-Type', 'application/json')
          .append('admin', mailID)
          .append('uuid', uid)
      })
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          reject(err);
        });
    });
  }

  getUsageMetricsInfomation(mailID, uid, userMail, timezone, formDate, todate, system, centerCode) {
    return new Promise((resolve, reject) => {
      this.http.get(this.mainUrl + 'tenant/' + system + '/usage?email=' + userMail + '&timezone=' + timezone + '&from=' + formDate + '&to=' + todate + '&center_code=' + centerCode, {
        headers: new HttpHeaders()
          .append('Content-Type', 'application/json')
          .append('admin', mailID)
          .append('uuid', uid)
      })
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          reject(err);
        });
    });
  }

  getLocalTimeZone(latLong, time) {
    return new Promise((resolve, reject) => {
      this.http.get('https://maps.googleapis.com/maps/api/timezone/json?location=' + latLong + '&timestamp=' + time + '&key=AIzaSyBWk8wsExfSTt-eg32ZS-x2UpWsh51JABQ', {
      })
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          reject(err);
        });
    });
  }

  getPaymentDetails(mailID, uid, phoneNo, timezone, paymentId) {
    return new Promise((resolve, reject) => {
      this.http.get(this.mainUrl + 'tenant/tele/payments?phone=%2B91' + phoneNo + '&timezone=' + timezone + '&payment_id=' + paymentId, {
        headers: new HttpHeaders()
          .append('Content-Type', 'application/json')
          .append('admin', mailID)
          .append('uuid', uid)
      })
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          reject(err);
        });
    });
  }

  getApponments(mailID, uid, from, to, timezone, emailID, mrnInfo) {
    return new Promise((resolve, reject) => {
      this.http.get(this.mainUrl + 'tenant/tele/appointments?from=' + from + '&to=' + to + '&timezone=' + timezone + '&email=' + emailID + '&mrn=' + mrnInfo, {
        headers: new HttpHeaders()
          .append('Content-Type', 'application/json')
          .append('admin', mailID)
          .append('uuid', uid)
      })
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          reject(err);
        });
    });
  }

  resendReportDetails(mailID, uid, cId) {
    var data = { consult_id: cId };
    return new Promise((resolve, reject) => {
      this.http.post(this.mainUrl + 'tenant/tele/report/resend', JSON.stringify(data), {
        headers: new HttpHeaders().append('Content-Type', 'application/json')
          .append('admin', mailID)
          .append('uuid', uid)
      })
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          reject(err);
        });
    });
  }

  cancelAppointement(mailID, uid, cId) {
    var data = { consult_id: cId };
    return new Promise((resolve, reject) => {
      this.http.post(this.mainUrl + 'tenant/tele/appointment/cancel', JSON.stringify(data), {
        headers: new HttpHeaders().append('Content-Type', 'application/json')
          .append('admin', mailID)
          .append('uuid', uid)
      })
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          reject(err);
        });
    });
  }

  sendPaymentReminderLink(mailID, uid, consultId, paymentId) {
    var data = { consult_id: consultId, id: paymentId };
    return new Promise((resolve, reject) => {
      this.http.post(this.mainUrl + 'tenant/tele/appointment/payment/reminder', JSON.stringify(data), {
        headers: new HttpHeaders().append('Content-Type', 'application/json')
          .append('admin', mailID)
          .append('uuid', uid)
      })
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          reject(err);
        });
    });
  }

  editPatientPhoneNumber(mailID, uid, cunsultId, phone) {
    var data = { consult_id: cunsultId, phone: '+91' + phone };
    return new Promise((resolve, reject) => {
      this.http.post(this.mainUrl + 'tenant/tele/patient/contact', JSON.stringify(data), {
        headers: new HttpHeaders().append('Content-Type', 'application/json')
          .append('admin', mailID)
          .append('uuid', uid)
      })
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          reject(err);
        });
    });
  }

  shiftAppointments(mailID, uid, name, email, department, idArray, pDate) {
    var data = {
      date: pDate,
      consultant: {
        name: name,
        email: email,
        department: department
      },
      consult_ids: idArray
    }
    return new Promise((resolve, reject) => {
      this.http.post(this.mainUrl + 'tenant/tele/appointments/shift', JSON.stringify(data), {
        headers: new HttpHeaders().append('Content-Type', 'application/json')
          .append('admin', mailID)
          .append('uuid', uid)
      })
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          reject(err);
        });
    });
  }

  getAvialbleSlots(mailID, uid, date, email, timezone) {
    return new Promise((resolve, reject) => {
      this.http.get(this.mainUrl + 'tenant/tele/consultant/availability?date=' + date + '&email=' + email + '&timezone=' + timezone, {
        headers: new HttpHeaders()
          .append('Content-Type', 'application/json')
          .append('admin', mailID)
          .append('uuid', uid)
      })
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          reject(err);
        });
    });
  }

  createNewAppointment(mailID, uid, data) {
    return new Promise((resolve, reject) => {
      this.http.post(this.mainUrl + 'tenant/tele/appointment/create_test', JSON.stringify(data), {
        // this.http.post(this.mainUrl + 'tenant/tele/appointment/create', JSON.stringify(data), {
        headers: new HttpHeaders().append('Content-Type', 'application/json')
          .append('admin', mailID)
          .append('uuid', uid)
      })
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          reject(err);
        });
    });
  }

  getAppoinmentTypes(mailID, uid, isPatientExist) {
    return new Promise((resolve, reject) => {
      this.http.get(this.mainUrl + 'tenant/tele/appointment/types?existing=' + isPatientExist, {
        headers: new HttpHeaders()
          .append('Content-Type', 'application/json')
          .append('admin', mailID)
          .append('uuid', uid)
      })
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          reject(err);
        });
    });
  }

  getOptionsList(mailID, uid) {
    return new Promise((resolve, reject) => {
      this.http.get(this.mainUrl + 'tenant/users/homecare', {
        headers: new HttpHeaders()
          .append('Content-Type', 'application/json')
          .append('admin', mailID)
          .append('uuid', uid)
      })
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          reject(err);
        });
    });
  }

  downloadIndividualPrescription(request_id, tenant_id) {
    var mediaType = 'application/pdf';
    return new Promise((resolve, reject) => {
      this.http.get(this.mainUrl + 'patient/prescription/download?request_id=' + request_id + '&tenant_id=' + tenant_id, {
        headers: new HttpHeaders().append('Content-Type', 'application/pdf').append('code', this.keyDownloadProscription),
        responseType: 'blob'
      })
        .subscribe(res => {
          var blob = new Blob([res], { type: "application/pdf" });
          saveAs(blob, "Prescription_" + new Date().getTime() + ".pdf");
          resolve(blob);
        },
          (err) => {
            reject(err);
          });
    });
  }

  downloadIndividualSummary(request_id, tenant_id) {
    var mediaType = 'application/pdf';
    return new Promise((resolve, reject) => {
      this.http.get(this.mainUrl + 'patient/advice/download?request_id=' + request_id + '&tenant_id=' + tenant_id, {
        headers: new HttpHeaders().append('Content-Type', 'application/pdf').append('code', this.keyDownloadProscription),
        responseType: 'blob'
      })
        .subscribe(res => {
          var blob = new Blob([res], { type: "application/pdf" });
          saveAs(blob, "Summary_" + new Date().getTime() + ".pdf");
          resolve(blob);
        },
          (err) => {
            reject(err);
          });
    });
  }

  convertDate(dateValue) {
    var monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    var startDate = +dateValue.split('-')[2];
    var startMonth = monthNames[(+dateValue.split('-')[1] - 1)];
    var year = +dateValue.split('-')[0];
    return startDate + " " + startMonth + " " + year;
  }

  convertTime(timeValue) {
    var hours = parseInt(timeValue.split(":")[0]); // gives the value in 24 hours format
    var AmOrPm = hours >= 12 ? 'PM' : 'AM';
    hours = (hours % 12) || 12;
    var minutes = timeValue.split(":")[1];
    var finalTime = hours + ":" + minutes + " " + AmOrPm;
    return finalTime;
  }

  convertUtcToLocalDate(val, locationTimezone) {
    var temp = '' + val;
    var temp1 = temp.split('T')[0];
    var temp2 = temp.split('T')[1];
    var d: any = new Date(Date.UTC(Number(temp1.split('-')[0]), Number(temp1.split('-')[1]) - 1, Number(temp1.split('-')[2]), Number(temp2.split(':')[0]), Number(temp2.split(':')[1]), Number(temp2.split(':')[2]))).toLocaleString("en-US", { timeZone: locationTimezone });
    return d;
  }

  getMobileFromMrn(mrn, orgId) {
    return new Promise((resolve, reject) => {
      this.http.get(this.mainUrl + 'patient/profiles?mrno=' + mrn + '&organizationId=' + orgId, {
        headers: new HttpHeaders().append('code', this.keyDownloadProscription)
      })
        .subscribe(res => {
          resolve(res);
        },
          (err) => {
            reject(err);
          });
    });
  }

  fetchExistingRecordswithMobile(mobilenumber, orgId) {
    return new Promise((resolve, reject) => {
      this.http.get(this.mainUrl + 'patient/profile-records?phone=%2B91' + mobilenumber + '&organizationId=' + orgId, {
        headers: new HttpHeaders().append('code', this.keyDownloadProscription)
      })
        .subscribe(res => {
          resolve(res);
        },
          (err) => {
            reject(err);
          });
    });
  }

  fetchExistingProfileswithMobile(mobilenumber, orgId, token) {
    let apiHeaders = {
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Methods': 'POST, GET, OPTIONS, PUT',
      'Authorization': `Bearer ${token}`
    }
    return this.http.get('https://grabi.bifrost.health/profilesnew?phone=%2B91' + mobilenumber + '&demoMode=false&organizationId=' + orgId, {
      headers: apiHeaders
    })
  }

  fetchExistingProfileswithMobileNew(mobilenumber, orgId) {
    return this.http.get(this.mainUrl + 'patient/profileList?phone=%2B91' + mobilenumber + '&demoMode=false&organizationId=' + orgId, {
        headers: new HttpHeaders().append('code', this.keyDownloadProscription)
      });
  }

  getToken() {
    return this.http.post('https://api.bifrost.health/authenticate', {
      "tenantId": "707321bf-4e5c-4881-bbf2-d082b2cb5d59",
      "apiKey": "oIJ8Q~F4JOi7iUXnk8madINwt46d4X8BEJ8uxaXz",
      "app": "grabi"
    }, { headers: { 'Content-Type': 'application/json' } })
  }

}